import React from 'react';

import CompanyConfigurationService from '../../../services/CompanyConfiguration';
import ArcelorBarcode from './ArcelorBarcode';

const COMPANY_BARCODE = {
  ARCELOR: 'ArcelorBarcode'
};

function BarcodeByCompany({ asset }) {
  if (!(asset.internalBarcode && asset.internalBarcode.code)) {
    return null
  }

  const companyBarcodeKey = CompanyConfigurationService.companyConfigurations.find(x => x.key === "ASSET_DETAIL_BARCODE_COMPONENT") || {}

  switch (companyBarcodeKey.value) {
    case COMPANY_BARCODE.ARCELOR:
      return <ArcelorBarcode asset={asset} />
    default:
      return (
        <li className="list-group-item">
          <b>Código de Barras Interno</b>: {asset.internalBarcode.code}
        </li>
      )
  }
}

export default BarcodeByCompany



// WEBPACK FOOTER //
// ./src/component/Asset/barcode/BarcodeByCompany.js